import React, { use, useContext } from 'react';
import './FeatureSection.css';
import Constants from "../locals/constants.json"
import {LanguageContext} from "../context/LanguageContext"



const FeatureSection = () => {
  const {t} = useContext(LanguageContext);
  return (
    <section className="feature-section">
      <div className="feature-header">
        <h2 className="feature-title">{t("features", "title")}</h2>
        <p className="feature-description">
          {t("features", "subtitle")}
        </p>
      </div>

      <div className="features-grid">
        {Constants.features.map((feature, index) => (
          <div key={index} className="feature-card">
            <span className="material-symbols-outlined notranslate feature-icon">
              {feature.icon}
            </span>
            <div className="feature-content">
              <h3 className="feature-card-title">{t("features")[feature.key]["title"]}</h3>
              <p className="feature-card-description">{t("features")[feature.key]["description"]}</p>
            </div>
            <div className="feature-pic"
              style={{ backgroundImage: `url(${feature.image})` }}
              role="img"
              aria-label={feature.title}
            > 
              
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeatureSection;